function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1762.16,307.88l-.278-1.069a6.922,6.922,0,0,1-.054-3.543,9.667,9.667,0,0,0,.1-4.587,9.951,9.951,0,1,0-9.731,11.858c1.47,0,1.765-.261,3.062-.261a16.551,16.551,0,0,1,3.776.662A2.541,2.541,0,0,0,1762.16,307.88Zm-2.475,1.14a20.516,20.516,0,0,0-4.423-.742c-1.475,0-1.811.261-3.062.261a7.917,7.917,0,0,1-7.881-6.668,7.966,7.966,0,0,1,15.657-2.768,7.648,7.648,0,0,1-.079,3.643,8.939,8.939,0,0,0,.05,4.569C1760.157,308.124,1760.546,309.02,1759.685,309.02Zm-10.57-8.059a2,2,0,1,1-2-2A2,2,0,0,1,1749.115,300.961Zm5,0a2,2,0,1,1-2-2A2,2,0,0,1,1754.115,300.961Zm5,0a2,2,0,1,1-2-2A2,2,0,0,1,1759.115,300.961Z",
  transform: "translate(-1742.242 -291.02)",
  fill: "#b40000"
});

var SvgMessageThreePoints = function SvgMessageThreePoints(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageThreePoints, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-three-points.33aecd84.svg";
export { ForwardRef as ReactComponent };